<template>
  <div :class="containerClassName">
    <slot name="label" :id="id" :label="label" :required="required">
      <label :for="id" v-if="!hideLabel">{{label}}<span v-if="required"> *</span></label>
    </slot>

    <div class="input-container date" :class="inputContainerClasses">
      <input
        type="date"
        autocomplete="off"
        :id="id"
        :name="name"
        :value="value"
        :class="inputClasses"
        :disabled="disabled"
        :readonly="readonly"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @keydown="onKeydown"
        @input="onInput"
        @blur="onBlur"
        @focus="onFocus"
      >
      <span v-if="!disabled" class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
      <span v-else class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-disabled"></use></svg></span>
      <span class="form-error-label" v-if="errors.has(name)">
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
        {{errors.first(name)}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheTextInput',
  inject: [
    '$validator'
  ],
  props: {
    label: {
      type: String,
      default: ''
    },
    containerClassName: {
      type: String,
      default: 'cell large-12'
    },
    id: {
      type: String,
      default: function () {
        return 'input-id-' + this._uid
      }
    },
    name: {
      type: String,
      default: null
    },
    value: {
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: String,
      default: null
    },
    disabled: {
      type: [Boolean, Number],
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputClasses: function () {
      let cls = []

      // Add the main class name
      cls.push(this.className)

      // Add disabled
      if (this.disabled) {
        cls.push('disabled')
      }

      // Add readonly
      if (this.readonly) {
        cls.push('readonly')
      }

      // Add error
      if (this.errors.has(this.name)) {
        cls.push('error')
      }

      return cls
    },
    inputContainerClasses: function () {
      let cls = []

      if (this.errors.has(this.name)) {
        cls.push('form-error')
      }

      if (this.disabled) {
        cls.push('disabled')
      }

      return cls
    }
  },
  methods: {
    onKeydown: function (e) {
      /*
      If we want to prevent chars

      console.log(e.keyCode)
      if (e.keyCode === 71) {
        e.preventDefault()
      }
      */
    },
    onInput (e) {
      this.$emit('input', e.target.value)
    },
    onBlur (e) {
      this.$emit('blur')
    },
    onFocus (e) {
      this.$emit('focus')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Inputs/TheDateInput.vue